<template>
  <div class="wrap common-container">
    <h2 class="public-title">文都教育</h2>
    <div class="company-profile el-row-overflow">
      <el-row :gutter="40">
        <el-col :md="12" :sm="10" :xs="24">
          <p class="profile-cover">
            <img src="@/assets/images/img/img_group.jpg" alt="">
          </p>
        </el-col>
        <el-col :md="12" :sm="14" :xs="24">
          <div class="profile-detail">
            <h3>文都简介</h3>
            <img class="en-profile" src="@/assets/images/img/img_profile.png" alt="">
            <div>
              <p>世纪文都教育科技集团是专注于大学生升学、就业和职业技能提升的专业化教育集团。公司总部位于北京市海淀区中关村高科技园区，业务覆盖大学教育、职业教育和校企合作等教育培训领域。文都教育以精彩课程、优质资料、专业服务、前沿技术、科学管理及全方位品牌建设，成为大学生领域的专业教育品牌。基于移动互联网、人工智能、大数据、云计算等技术的应用，文都教育打造以文都教育大数据、文都智能学习系统、文都教育新生态为核心的文都智慧教育。</p>
              <p>
                  文都教育先后取得了高新技术企业证书、中关村高新技术企业证书、广播电视节目制作许可证、出版物经营许可证、电信与信息服务业务经营许可证、信息系统安全等级保护备案证明等多种行业和专业资质，文都教育集团旗下学校已取得办学许可证。截至2021年，公司累计申请商标、专利、软件和作品著作权等知识产权1100多件。
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
export default defineComponent({
  setup() {
    return {};
  }
});
</script>

<style lang="scss" scoped type="text/scss">
.company-profile{
    padding:32px;
    background:#fff;
    .profile-cover{
        img{
            width:100%;
        }
    }
    .profile-detail{
        color:#1B1D1F;
        font-size:14px;
        line-height: 20px;
        h3{
            font-size:24px;
            line-height: 36px;
        }
        .en-profile{
            width:80%;
            max-width:460px;
            padding:16px 0 8px;
        }
        p{
            margin-top:24px;
        }
    }
}
</style>